<!--HEADER-->
<div class="additional-booking-confirm__header row" id="additionalBookingConfirmHeader">
  <div class="additional-booking-confirm__header-col col-12">
    <h3 class="additional-booking-confirm__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_confirm_intro')"
        [innerHTML]="translationService.getTranslation('additionalBooking_confirm_intro')"></h3>
  </div>
  @if (isQualified) {
    <div class="additional-booking-confirm__header-col col-12">
      <p class="additional-booking-confirm__description"
         *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_confirm_description')"
         [innerHTML]="translationService.getTranslation('additionalBooking_confirm_description')"></p>
    </div>
  }
</div>

<div class="additional-booking-confirm__content row">
  <div class="additional-booking-confirm__content-col col-12">

    @if (isLoading) {
      <div class="additional-booking-confirm__spinner" style="text-align: center;">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }

    @if (!isLoading) {
      <app-general-errors [errors]="errors"></app-general-errors>

      <!--PRODUKT, DAS GEBUCHT WIRD-->
      @if (isQualified && product) {
        <mat-card appearance="outlined" class="mt-3">
          <div class="row m-3">
            <div tabindex="0" class="col-12">
              <mat-card-subtitle class="additional-booking-confirm__product-label"
                                 [innerHTML]="translationService.getTranslation('additionalBooking_confirm_product_label')">
              </mat-card-subtitle>
              <mat-card-title>{{ product.description }}</mat-card-title>
            </div>
          </div>
        </mat-card>
      }
    }

    <!--LAUFENDE BESTELLUNG: Kopf und Produkt bleiben stehen, bis auf die Bestaetigungsseite
        navigiert wird - eine leere Seite waehrend der Anlage waere nicht nachvollziehbar.-->
    @if (isBooking) {
      <div class="additional-booking-confirm__spinner" style="text-align: center;">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }

    <!--AKTIONEN-->
    @if (!isLoading && !isBooking) {
      <div class="additional-booking-confirm__actions">
        <button mat-raised-button (click)="goBack()"
        [innerHTML]="translationService.getTranslation('button_back')"></button>
        @if (isQualified) {
          <button mat-raised-button color="primary"
                  [disabled]="!canConfirm" (click)="confirmBooking()"
                  [innerHTML]="translationService.getTranslation('additionalBooking_button_confirm')"></button>
        }
      </div>
    }
  </div>
</div>
